import { Flex } from '@chakra-ui/react';
import { useReviewCreationData } from 'reducers/reviewCreationSlice';

import { REVIEW_PROVIDER_TYPES } from 'constants/ProjectConstants';

import { SelectionGridTable } from 'uiToolkitV1/SelectionGridTable';
import { TooltipInfoV1 } from 'uiToolkitV1/TooltipInfoV1';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { useTemplateMetadata } from '../../../Hooks/dataHooks/shareResultsDataHooks';

export const QuestionTypeVisibilitySettings = ({ feedbackFormId }) => {
  const { reviewCycleId } = useReviewCreationData();

  const templateMetadata = useTemplateMetadata({
    reviewCycleId,
    feedbackFormId,
    providerType: REVIEW_PROVIDER_TYPES.MANAGER,
  });

  const hasGoalQuestions = templateMetadata?.template?.templateSetting?.overallRatingDistribution?.PERFORMANCE > 0;
  const hasCompetencyQuestions = templateMetadata?.template?.templateSetting?.overallRatingDistribution?.POTENTIAL > 0;
  const hasQNAQuestions = templateMetadata?.template?.templateSetting?.overallRatingDistribution?.QNA > 0;

  const tableHeaders = [];
  const tableOptions = [];
  const onChangeHandlers = [];
  if (hasGoalQuestions) {
    tableHeaders.push('Overall Goals Score');
    tableOptions.push({
      label: 'Show',
      checked: true,
      disabled: true,
    });
  }
  if (hasCompetencyQuestions) {
    tableHeaders.push('Overall Competency Score');
    tableOptions.push({
      label: 'Show',
      checked: true,
      disabled: true,
    });
  }
  if (hasQNAQuestions) {
    tableHeaders.push('Overall Q&A Score');
    tableOptions.push({
      label: 'Show',
      checked: true,
      disabled: true,
    });
  }
  tableHeaders.push('Overall Score');
  tableOptions.push({
    label: 'Show',
    checked: true,
    disabled: true,
  });

  const handleChange = (checked: boolean, i: number, j: number) => {
    onChangeHandlers[j]?.(checked);
  };

  return (
    <Flex flexDir="column" gap={3}>
      <Flex alignItems="center" gap={2}>
        <TextBodyMedium>
          What granularity of scores can the Manager/Dotted Line Manager see in the shared report card?
        </TextBodyMedium>
        <TooltipInfoV1 title="Post the review publish, visibility of average sectional scores  to the Manager or Dotted Line Manager" />
      </Flex>
      <SelectionGridTable headers={tableHeaders} rows={[tableOptions]} onChange={handleChange} />
    </Flex>
  );
};
